import * as React from 'react'

import { Grid } from '@/components/ui/shadcn-compat'

class HomeSearchForm extends React.Component<React.PropsWithChildren> {
  render () {
    return (
      <Grid.Row className='home-search-wrapper-margin'>
        <Grid.Col className='HomeSearchWrapper'>
          <div className='container'>
            {this.props.children}
          </div>
        </Grid.Col>
      </Grid.Row> 
    )
  }
}

export default HomeSearchForm
